// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","624":"4924ee278d4a49a58e98afa4945bc5095b8aa261","888":"component---src-pages-prime-tsx"}[chunkId] + "-" + {"245":"b8cf012001c100ea24ca","453":"eebbcbf55ad033aff3e4","624":"13e4fffe7ee922459492","888":"6088675a5075b2724953"}[chunkId] + ".js";
};